<template>
  <div class="container mt-3 mb-3 tex-center p-3">
    <input
      type="file"
      accept="image/*"
      id="uploader"
      class="d-none"
      @change="readURL"
      
    />

    <div style="display: flex; pointer: cursor">
      <div
        v-if="this.$route.params.Status == 'Add'"
        style="height: 180px; width: 180px; overflow: hidden"
        class="reounded border"
      >
        <img
          id="blah"
          style="cursor: pointer"
          @click="upload"
          src="/image/Upload.png"
          alt="لوگو شعبه"
        />
      </div>
      <div
        v-if="
          this.$route.params.Status == 'Edit' &&
          this.$store.state.DefineShobe.EditData[0].imgLogoShobe != ''
        "
        style="height: 180px; width: 180px; overflow: hidden"
        class="reounded border"
      >
        <img
          id="blah"
          style="cursor: pointer"
          @click="upload"
          :src="source"
          alt="لوگو شعبه"
        />
      </div>

      <div style="flex: 1" class="mr-2">
        <div class="alert alert-warning">
          تصویر مورد نظر خود را با توجه به شرایط زیر آپلود کنید
        </div>
        <div class="alert alert-secondary">
          <p>فرمت تصویر مورد نظر یکی از فرمت های JPEG, JPG,PNG, SVG باشد</p>
          <p>حجم تصویر ارسالی بیش از یک مگابایت نباشد.</p>
        </div>
        <button
          @click.prevent="DeleteImg"
          v-if="this.parent.ImgLogoShobe && this.parent.ImgLogoShobe != 'null'"
          class="btn btn-default"
        >
          حذف تصویر
        </button>
        <button
          id="btnCancelmodal"
          data-dismiss="modal"
          class="btn btn-danger mr-1 d-none"
          dir="ltr"
        ></button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    upload() {
      document.getElementById("uploader").click();
    },
    Cancel() {
      document.getElementById("btnCancelmodal").click();
    },
    SetNew() {
      this.parent.imgLogoShobe = null;
      this.source = "/image/Upload.png";
      this.$store.state.DefineShobe.EditData[0].ImgLogoShobe = null;
      this.$mySweetDefaultTost(
        "حذف اطلاعات",
        "حذف لوگو انجام شد لطفا برای ثبت نهایی از دکمه ثبت اصلاحات استفاده نمایید",
        "success",
        3000
      );
    },
    DeleteImg() {
      this.$SweetQustion(
        "خذف اطلاعات",
        "آیا از حذف لوگو اطمینان دارید ",
        "warning",
        "بله",
        "خیر",
        null,
        this.SetNew,
        this.Cancel
      );
    },

    readURL(e) {
      const file = e.target.files[0]
    if (!file) return

    const allowedExtensions = ['gif', 'jpg', 'jpeg', 'png', 'zip', 'rar', 'pdf']
    const fileExtension = file.name.split('.').pop().toLowerCase()
    if (!allowedExtensions.includes(fileExtension)) {
      this.$mySweetDefaultTost(
        'فرمت فایل مجاز نیست',
        `فرمت ${fileExtension} پشتیبانی نمی‌شود.`,
        'error',
        3000
      )
      e.target.value = ''
      return
    }
      const input = e.target;
      if (input.files && input.files[0]) {
        if (input.files[0].size < 1 * 1024 * 1024) {
          var reader = new FileReader();
          var inputfile = input.files[0];

          reader.onload = function (e) {
            document
              .getElementById("blah")
              .setAttribute("src", e.target.result);
          };
          reader.readAsDataURL(input.files[0]);

          // console.log(input.files[0]);
        } else {
          this.$mySweetDefaultTost(
            "خطا",
            "حجم تصویر انتخاب شده بیش از حد مجاز است",
            "warning",
            2000
          );
          input.value = "";
        }
        this.test(inputfile);

        this.$store.state.DefineShobe.Data[0].imgLogoShobe = inputfile;
      }
    },
    test(a) {
      if (this.$route.params.Status == "Edit") {
        this.$store.state.DefineShobe.EditData[0].imgLogoShobe = a;
      } else if (this.$route.params.Status == "Add") {
        this.$store.state.DefineShobe.Data[0].imgLogoShobe = a;
      }
    },
  },
  props: ["parent"],
  data() {
    return {
      source: "data:image/png;base64, " + this.parent.ImgLogoShobe,
    };
  },
  mounted() {
    if (
      this.parent.ImgLogoShobe == null ||
      this.parent.ImgLogoShobe == "null"
    ) {
      this.source = "/image/Upload.png";
    }
    // console.log(this.parent.ImgLogoShobe!='null');
    // this.$store.state.DefineShobe.Data.imgLogoShobe=this.Omid
  },
  Computed: {},
};
</script>

<style scoped>
img {
  max-width: 180px;
}
input[type="file"] {
  padding: 10px;
  background: #2d2d2d;
}

#uploader {
  cursor: pointer;
}
</style>
